import axios from '@/plugins/axios'

export function getUsers(params = {}) {
    return axios.get('user', {
        params,
    })
}

export function getUserNumber() {
    return axios.get('user/number')
}

export function getUserMoneySum() {
    return axios.get('user/moneySum')
}

export function updateUsersStatus(data) {
    return axios.post(`user/status`, data)
}

export function getUserWallet(params) {
    return axios.get('user/wallet', {
        params,
    })
}

export function updateUser(id, data) {
    return axios.put(`user/${id}`, data)
}

export function userReturnDeposit(data) {
    return axios.post(`user/returnDeposit`, data)
}

export function userReturnOutTimeDeposit(data) {
    return axios.post(`user/returnOutTimeDeposit`, data)
}


export function userReReturnDeposit(data) {
    return axios.post(`user/reReturnDeposit`, data)
}

export function groupSendSms(data) {
    return axios.post(`user/groupSendSms`, data)
}

export function getGroupSendSmsList(params = {}) {
    return axios.get(`user/groupSendSmsList`, {params})
}

export function getGroupSmsTemplate(params = {}) {
    return axios.get(`user/groupSmsTemplate`, {params})
}

export function getUserByMobile(params = {}) {
    return axios.get(`user/getUserByMobile`, {params})
}

export function rechargeBalanceToUser(data) {
    return axios.post(`user/rechargeBalance`, data)
}

export function refundBalanceToUser(data) {
    return axios.post(`user/refundBalance`, data)
}

export function refundBalanceOrders(params = {}) {
    return axios.get('user/refundBalanceOrders', {
        params,
    })
}

export function queryRefundBalance(params = {}) {
    return axios.get('user/queryRefundBalance', {
        params,
    })
}

export function refundBalanceAgain(params = {}) {
    return axios.get('user/refundBalanceAgain', {
        params,
    })
}

export function getStudents(params = {}) {
    return axios.get('user/students', {
        params,
    })
}

export function editStudents(data = {}) {
    return axios.post('user/student', data)
}

export function getUserStuentNumber() {
    return axios.get('user/studentsNumber')
}

